import React from 'react'

import { ButtonProps as BaseButtonProps, Tooltip, TooltipProps } from '@mui/material'

import { StyledButton } from './StyledButton'

export type ButtonProps = Omit<BaseButtonProps, 'disableRipple' | 'variant'> & {
  primary?: boolean
  secondary?: boolean
  outlined?: boolean
  round?: boolean
  text?: boolean
  tooltipTitle?: string
  slotProps?: {
    tooltip?: Omit<TooltipProps, 'title' | 'children'>
  }
}

// es-lint-disable-next-line @typescript-eslint/no-unused-vars
export const Button: React.FC<ButtonProps> = ({
  round, primary, secondary, outlined, text, tooltipTitle, slotProps, ...props
}) => {
  const buttonProps: BaseButtonProps = props

  if (primary) {
    buttonProps.color = 'primary'
    buttonProps.variant = 'contained'
  } else if (secondary) {
    buttonProps.color = 'secondary'
    buttonProps.variant = 'contained'
  } else if (outlined) {
    buttonProps.variant = 'outlined'
  } else if (text) {
    buttonProps.variant = 'text'
  } else {
    buttonProps.color = 'primary'
    buttonProps.variant = 'contained'
  }

  buttonProps.disableRipple = true

  return buttonProps.disabled ? (
    <StyledButton size="small" $round={round} {...buttonProps} />
  ) : (
    <Tooltip title={tooltipTitle || ''} arrow {...slotProps?.tooltip}>
      <StyledButton size="small" $round={round} {...buttonProps} />
    </Tooltip>
  )
}
